var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row content"},[_c('iframe',{attrs:{"src":"https://ecertia.dekalab.com/Delivery/85fa2834-44e3-439f-8c09-cac8f05d0a2c","width":"100%","height":"900px"}})])])
}]

export { render, staticRenderFns }